module.exports = __webpack_public_path__ + "f4a4234046ed2a0fe9cffee50d0d359d.svg";